import { createFileRoute } from "@tanstack/react-router"
import { Crumb } from "modules/shared/lib/breadcrumbs"

import "modules/customers/lang"

export const Route = createFileRoute("/_base/_auth/customers")({
  loader: ({ route: { fullPath } }) => {
    return new Crumb({
      fullPath,
      title: (t) => t("customers.header.title"),
    })
  },
})
